import React, { useState, useEffect } from 'react';
import {
    InputAdornment,
    IconButton
} from '@material-ui/core';

import FilterContainer from '../../components/FilterContainer';
import DataTable from '../../components/DataTable';
import Loading from '../../components/Loading';
import ActionMenu from '../../components/ActionMenu';
import ConfirmationDialog from '../../components/ConfirmationDialog';

import SearchIcon from '@material-ui/icons/Search';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

import Instituicoes from '../../services/Instituicoes';
import { useAuth } from '../../AuthContext';

const ListaInstituicoes = (props) => {
    const { user } = useAuth();
    const [data, setData] = useState({
        isLoading: true,
        error: null,
        docs: [],
        page: 0,
        size: 30,
        count: 0
    });

    const [remove, setRemove] = useState({
        open: false,
        name: '',
        id: ''
    });

    const Listar = (page, size, filter) => {
        Instituicoes.list(page, size, filter).then(servicos => {
            setData({
                isLoading: false,
                docs: servicos.docs,
                page: servicos.page - 1,
                size: servicos.limit,
                count: servicos.totalDocs
            });
        }).catch(error => {
            console.log(error);
        });
    }

    useEffect(() => {
        sessionStorage.setItem("@stk/appTitle", "Instituições");
        Listar(data.page, data.size);
    }, [data.page, data.size]);

    const handleChangePage = (event, newPage) => {
        const { size } = data;
        Listar(newPage, size);
    }

    const handleChangeSize = (event) => {
        Listar(0, +event.target.value);
    }

    const applyFilters = (searchExpression) => {
        let filters = "";

        if (searchExpression) {
            filters += "&$or[0][nome][$regex]=" + searchExpression;
            filters += "&$or[0][nome][$options]=gi";
            filters += "&$or[1][cidade][$regex]=" + searchExpression;
            filters += "&$or[1][cidade][$options]=gi";
            filters += "&$or[2][estado][$regex]=" + searchExpression;
            filters += "&$or[2][estado][$options]=gi";
        }

        Listar(data.page, data.size, filters);
    }

    const handleKeyUpSearch = (event) => {
        if (event.keyCode === 13) applyFilters(event.target.value);
    }

    const handleApplyFilters = () => {
        let searchExpression = document.getElementById("search").value;
        applyFilters(searchExpression);
    }

    const handleDismissFilters = () => {
        document.getElementById("search").value = '';
        applyFilters();
    }

    const handleClickDelete = (event, id, name) => {
        setRemove({
            open: true,
            name: name,
            id: id
        })
    }

    const handleDeleteInstituicao = (event) => {
        Instituicoes.remove(remove.id).then(response => {
            setRemove({
                open: false,
                name: '',
                id: ''
            });

            let searchExpression = document.getElementById("search").value;
            applyFilters(searchExpression);
        }).catch(error => {
            console.log(error);
        });
    }

    const columns = [
        {
            id: 'nome',
            label: 'Nome',
            align: 'left'
        },
        {
            id: 'cidade',
            label: 'Cidade',
            align: 'center'
        },
        {
            id: 'estado',
            label: 'Estado',
            align: 'center'
        },
        {
            id: 'id',
            label: 'Ações',
            align: 'center',
            type: 'hybrid',
            format: (doc) => (
                <div>
                    <IconButton aria-label="Editar" href={'/instituicoes/' + doc._id} color="primary">
                        {user?.permissoes["Instiuições-alterar"] ? (
                            <EditIcon color="primary" />
                        ) : (
                                <VisibilityIcon color="primary" />
                            )}
                    </IconButton>
                    {user?.permissoes["Instiuições-excluir"] && (
                        <IconButton aria-label="Editar" onClick={e => handleClickDelete(e, doc._id, doc.nome)} color="secondary">
                            <DeleteIcon />
                        </IconButton>
                    )}
                </div>
            )
        }
    ];

    const filters = [
        {
            type: 'search',
            id: 'search',
            label: 'Filtrar por nome',
            width: 300,
            InputProps: {
                startAdornment: <InputAdornment position="start">
                    <SearchIcon />
                </InputAdornment>,
            },
            onKeyUp: handleKeyUpSearch
        }
    ];

    const { isLoading, docs, page, size, count, error } = data;

    return (!isLoading && docs ?
        <>
            <FilterContainer
                title="Filtros"
                filters={filters}
                handleApplyFilters={handleApplyFilters}
                handleDismissFilters={handleDismissFilters}
            />
            <DataTable
                columns={columns}
                docs={docs}
                page={page}
                size={size}
                count={count}
                error={error}
                handleChangePage={handleChangePage}
                handleChangeSize={handleChangeSize}
            />
            {user?.permissoes["Instituições-incluir"] && (
                <ActionMenu
                    actions={[
                        {
                            icon: <IconButton href="/instituicoes/new"><DescriptionOutlinedIcon /></IconButton>,
                            title: 'Incluir',
                            type: 'button'
                        }
                    ]}
                />
            )}
            <ConfirmationDialog
                title="Tem certeza que seja excluir?"
                confirmTitle="Sim"
                confirm={handleDeleteInstituicao}
                cancelTitle="Não"
                cancel={() => {
                    setRemove({
                        ...remove,
                        open: false
                    })
                }}
                open={remove.open}
                onClose={() => {
                    setRemove({
                        ...remove,
                        open: false
                    })
                }}
            >{remove.name}</ConfirmationDialog>
        </>
        :
        isLoading && <Loading open={isLoading} />
    )
}

export default ListaInstituicoes;